module.exports = __webpack_public_path__ + "img/times-circle.db0dc276.svg";